import axios from '@/axios';
import { AxiosInstance } from 'axios';
import type { TPayScansPayload, TPayScansResponse } from '../models/types';

const axiosInstance = axios as AxiosInstance;

export async function getAvailableScans(): Promise<number> {
  const response = await axiosInstance.get<number>('/private/ui/scan_packs/user/available_scans');
  return response.data;
}

export async function activateCode(activationCode: string): Promise<void> {
  await axiosInstance.post('/private/ui/coupons/activate_code', { activationCode });
}

export async function payForScans(payload: TPayScansPayload): Promise<TPayScansResponse> {
  const response = await axiosInstance.post<TPayScansResponse>('/private/ui/pay/scans', payload);
  return response.data;
}
